import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "blog",
  adminPrefix: "",
  fetchOne: true,
  legacy: {
    data: "blogs",
    count: "count",
    selected: "blog",
    setSelected: "setBlog",
    fetch: "fetchBlogs",
    fetchOne: "fetchOneBlog",
    create: "createOneBlog",
    update: "updateBlog",
    remove: "deleteBlog",
    updateState: "updateBlogState",
  },
});

export const BlogProvider = Provider;
export const useBlogContext = useValue;
